var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.district.CWP_ALLOW_PAYMENTS_FLG &&
    _vm.district.CWP_ALLOW_PAYMENTS_FLG === "Y"
    ? _c(
        "div",
        { staticClass: "sapphire-payment-portal" },
        [
          !!_vm.balance
            ? _c("div", [
                _c("h3", { staticStyle: { "margin-bottom": "0px" } }, [
                  _vm._v(
                    "Balance: " +
                      _vm._s(
                        _vm._f("dollar")(
                          parseFloat(_vm.balance.BALANCE).toFixed(2)
                        )
                      )
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("i", [
                    _vm.balance.MODIFIED_DATE !== ""
                      ? _c("small", [
                          _vm._v(
                            "Last updated as of " +
                              _vm._s(
                                _vm._f("datetime")(
                                  _vm.balance.MODIFIED_DATE,
                                  "MMMM, DD YYYY HH:mm:ss",
                                  "MM/DD/YYYY h:mm a"
                                )
                              )
                          )
                        ])
                      : _c("small", [_vm._v("last update not available")])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.paymentsAreAllowed && !_vm.userIsAdmin
            ? [
                _vm.studentHasSingleEnrollment || _vm.webstores.length === 1
                  ? _c("div", [
                      _c("p", [
                        _c("em", [
                          _vm._v(
                            _vm._s(_vm.buildVancoWebstoreName(_vm.webstores[0]))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticStyle: { cursor: "pointer" },
                          attrs: {
                            target: "_blank",
                            href: _vm.buildVancoWebstoreUrl(_vm.webstores[0])
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "includes/images/RevTrakPay.svg",
                              height: "35",
                              alt: "RevTrak"
                            }
                          })
                        ]
                      )
                    ])
                  : _c("div", [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticStyle: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.setShowWebstoreModal(true)
                            }
                          }
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: "includes/images/RevTrakPay.svg",
                              height: "35",
                              alt: "RevTrak"
                            }
                          })
                        ]
                      )
                    ])
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [_c("em", [_vm._v("Choose Webstore")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }